import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import JourneyProp from '../../propTypes/journeyProp';
import translate from '../../../../commonComponents/translate';
import JourneyStats from '../stats/JourneyStats';
import JourneyStepProp from '../../propTypes/journeyStepProp';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';

function JourneyDetailsInfo({ t, selected, selectedStep, isEnrolled }) {
  const summary = `${t('journey_summary')}: ${selected.summary}`;
  const { loggedUser } = useContext(LoggedUserContext);
  return (
    <div className="journey-overall-information">
      <div className="row">
        {!isEnrolled && <div className="enroll-overlay" style={{ width: '92%', height: '98%', left: '13px' }} />}
        <div className="col-lg-12 journey-overall-list">
          <div className="col-lg-12  col-md-6">
            <div className="journey-overall-list-img">
              <img
                src={
                  selected.image
                    ? selected.image.url
                    : '/images/no_image_upload.png'
                }
                alt="course"
              />
            </div>
            <h3>{selected.title}</h3>
            {selected.summary &&
              <p>{summary}</p>
            }
            <p>{`${selected.steps.length} ${t('academy.steps.journey')}`}</p>
            {loggedUser && (
              <div className="journey-stats">
                <JourneyStats
                  journey={selected}
                  step={selectedStep}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

JourneyDetailsInfo.propTypes = {
  t: PropTypes.func.isRequired,
  selected: PropTypes.shape(JourneyProp.propType).isRequired,
  selectedStep: PropTypes.shape(JourneyStepProp.propType).isRequired,
  isEnrolled: PropTypes.bool,
};

JourneyDetailsInfo.defaultProps = {
  isEnrolled: false,
};

export default translate(JourneyDetailsInfo);
